export default class Sandbox {
    constructor(adapter) {
        this.client = adapter.getSandboxClient()
    }

    async spark(name, data, options) {
        const { data: results } = await this.client.post(`/spark/exec/${name}`, data, options)

        return results
    }
}